import React from 'react';
import BgImg from "../../images/services-usa/game_update/bg_img.webp"
import {Container, Row,Col} from "react-bootstrap";
import {StaticImage} from "gatsby-plugin-image";

function DevelpeServices(props) {
    return (
        <section className="develop_servies p-100" style={{backgroundImage: `url(${BgImg})`}}  >
            <Container>
                <Row>
                    <Col xs={12} md={8} lg={8} xl={8} className="m-auto text-center">
                        <h2>When To Consider Our Mobile Game Development Services</h2>
                        <p>We offer comprehensive game app solutions tailored to the unique needs of businesses including startups to large-scale enterprises. We can engineer and deliver your product in 12 to 18 months.</p>
                    </Col>
                </Row>
                <Row className='services_develop_container' >
                    <Col xs={12} md={12} lg={4}>
                        <div className="services_develop_box">
                            <div className="main_title">
                                <div className="tit">
                                    Launching<br/>
                                    a New Game
                                </div>
                                <div className="icon">
                                    <StaticImage
                                        src="../../images/services-usa/game_update/icon_01.svg"
                                        alt="tekrevol_game_development"
                                        className="img-fluid"
                                        layout="constrained"
                                        placeholder="blurred"
                                        formats={["webp"]}
                                        width={99}
                                        height={99}
                                    />
                                </div>
                            </div>
                            <div className="content">
                                <p>If you're an aspiring game entrepreneur with a groundbreaking idea for the next big mobile game but lack the technical expertise to bring it to life, consider our game app development services. We specialize in turning innovative concepts into fully functional, market-ready games.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <div className="services_develop_box">
                            <div className="main_title">
                                <div className="tit">
                                    Educational<br/>
                                    Institutions Going Digital
                                </div>
                                <div className="icon">
                                    <StaticImage
                                        src="../../images/services-usa/game_update/icon_02.svg"
                                        alt="tekrevol_game_development"
                                        className="img-fluid"
                                        layout="constrained"
                                        placeholder="blurred"
                                        formats={["webp"]}
                                        width={106}
                                        height={102}
                                    />
                                </div>
                            </div>
                            <div className="content">
                                <p>We can design educational games that make learning enjoyable, interactive, and effective for students of all ages.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <div className="services_develop_box">
                            <div className="main_title">
                                <div className="tit">
                                    Existing Apps<br/>
                                    in Need of Gamification
                                </div>

                                <div className="icon">
                                    <StaticImage
                                        src="../../images/services-usa/game_update/icon_03.svg"
                                        alt="tekrevol_game_development"
                                        className="img-fluid"
                                        layout="constrained"
                                        placeholder="blurred"
                                        formats={["webp"]}
                                        width={130}
                                        height={66}
                                    />
                                </div>
                            </div>
                            <div className="content">
                                <p>When your existing app could benefit from gamification elements to boost user engagement and retention, our expertise comes into play. We can seamlessly integrate game features into your app, transforming it into an interactive and enjoyable experience for users.</p>
                            </div>
                        </div>
                    </Col>
                  </Row>
            </Container>
        </section>
    );
}
export default DevelpeServices;